<swb-modal #modal="modal" *ngIf="isInitialized">
  <div modal-header [innerHTML]="headerTitle"></div>
  <div modal-body>
    <form [formGroup]="form" (ngSubmit)="save()" [method]="'post'" *ngIf="isInitialized">
      <swb-form-fields [fields]="formEditors" [form]="form"></swb-form-fields>
    </form>
  </div>
  <div modal-footer>
    <button class="cta cta--red" (click)="modal.closeModal({submitted: false})">Zrušit</button>
    <button class="cta cta--green cta--in" (click)="save()">Uložit</button>
  </div>
</swb-modal>